module.exports = __webpack_public_path__ + "static/media/facebook.573245b3.png";